import Vue from "vue";
import { Button, NavBar, Icon, List, Toast, Checkbox, Tab, Tabs, PullRefresh, Loading, Dialog, Slider, Sticky } from "vant";
import { Image as VanImage } from "vant";
import { Form } from 'vant';
import { Field } from 'vant';
import { RadioGroup, Radio } from 'vant';
import { Popup } from 'vant';
import { Popover } from 'vant';

Vue.use(Popover);
Vue.use(Popup);
Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(Form);
Vue.use(Field);
Vue.use(Dialog);
Vue.use(Loading);
Vue.use(PullRefresh);
Vue.use(Tab);
Vue.use(Tabs);
Vue.use(Checkbox);
Vue.use(Toast);
Vue.use(List);
Vue.use(VanImage);
Vue.use(Icon);
Vue.use(NavBar);
Vue.use(Button);
Vue.use(Slider);
Vue.use(Sticky);